import { useState, useCallback } from "react";
import { WizardState, WizardActions, WizardStepData } from "../definitions";

export const useWizardState = (
  initialStepIndex: number = 0
): [WizardState, WizardActions] => {
  const [activeStepIndex, setActiveStepIndex] = useState(initialStepIndex);
  const [stepData, setStepDataState] = useState<WizardStepData>({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const setStepData = useCallback((stepIndex: number, data: any) => {
    setStepDataState((prev) => ({
      ...prev,
      [stepIndex]: data,
    }));
  }, []);

  const reset = useCallback(() => {
    setActiveStepIndex(0);
    setStepDataState({});
    setIsSubmitting(false);
  }, []);

  const state: WizardState = {
    activeStepIndex,
    stepData,
    isSubmitting,
  };

  const actions: WizardActions = {
    setActiveStepIndex,
    setStepData,
    setIsSubmitting,
    reset,
  };

  return [state, actions];
};
